<template>
    <!--培训任务-->
  <div class="alltext">
    <div v-if="liad_show">
      <load></load>
    </div>
      <div class="firstdiv">
        <router-link :to="{path:'entryadd',query:{num:''}}">
         <el-button type="primary" icon="el-icon-document-add" class="btnadd">制定入职任务</el-button>
        </router-link>
      </div>
      <div class="content">
       <div class="content_right">
         <span style="font-size: 20px;">入职任务</span>
        <div>
          <el-dialog
            title="修改任务主题"
            :visible.sync="edittask_name.dialogVisible"
            width="30%"
            >
            <el-input v-model="edittask_name.input" placeholder="请输入内容"></el-input>
            <span slot="footer" class="dialog-footer">
              <el-button @click="edittask_name.dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="edittask_ok">确 定</el-button>
            </span>
          </el-dialog>
          <el-table :data="task_list.list" stripe style="width: 100%" :default-sort="{prop: 'num', order: 'descending'}">
             <el-table-column prop="num" label="编号" sortable>
             </el-table-column>
             <el-table-column label="主题(双击可修改)" width="" sortable>
               <template slot-scope="scope">
                 <div @dblclick="changeEnddate(scope.$index, scope.row)" >
                 <span >{{scope.row.name}}</span>
                 </div>
               </template>
             </el-table-column>
             <el-table-column prop="t_id" label="分类" sortable>
             </el-table-column>
             <el-table-column label="培训级别" sortable>
               <template slot-scope="scope">
                 <span v-if="scope.row.role_type==0">企业级</span>
                 <span v-if="scope.row.role_type==1">部门级</span>
                 <span v-if="scope.row.role_type==2">个人级</span>
               </template>
             </el-table-column>
             <el-table-column prop="a_id" label="派发人" sortable>
             </el-table-column>
             <el-table-column prop="c_time" label="创建时间" sortable>
             </el-table-column>
             <el-table-column prop="day" label="培训周期(天)" sortable>
             </el-table-column>
             <el-table-column prop="companyee.length" label="学员数" sortable>
             </el-table-column>
             <el-table-column label="变更记录">
                 <template slot-scope="scope">
                   <span v-if="scope.row.change.length==0">无</span>
                   <el-button v-else round  size="small" @click="train_change_watch(scope.row)">查看</el-button>
                 </template>
             </el-table-column>
             <el-table-column label="状态">
                 <template slot-scope="scope">
                   <span v-if="scope.row.status=='0'">编辑中</span>
                   <span v-if="scope.row.status=='1'">启用中</span>
                   <span v-if="scope.row.status=='2'">已禁用</span>
                   <span v-if="scope.row.status=='3'">已删除</span>
                 </template>
             </el-table-column>
             <el-table-column align="center">
               <template slot="header" slot-scope="scope">
                 <el-input v-model="search" size="mini" @keyup.enter.native="search_click()" placeholder="输入关键字搜索" />
               </template>
               <template slot-scope="scope">
                 <router-link :to="{path:'entryadd',query:{num:scope.row.num}}" v-if="scope.row.status=='0'">
                   <i class="el-icon-edit"></i>
                 </router-link>
                <i class="el-icon-view"  @click="train_info_watch(scope.row)" ></i>
                    <el-dropdown >
                      <span class="el-dropdown-link">
                        <i class="el-icon-more-outline" v-if="scope.row.status !='3'"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                         <el-dropdown-item v-if="scope.row.status=='0'" @click.native="() => train_up('push', scope.row)">发布</el-dropdown-item>
                         <el-dropdown-item v-if="scope.row.status!='0'" @click.native="() => push_status(scope.row.num)">检测</el-dropdown-item>
                          <el-dropdown-item v-if="scope.row.status=='1'" @click.native="() => train_up('status', scope.row)" >禁用</el-dropdown-item>
                          <el-dropdown-item v-if="scope.row.status=='2'" @click.native="() => train_up('status', scope.row)">启用</el-dropdown-item>
                          <el-dropdown-item v-if="scope.row.status!='3'" @click.native="() => train_up('del',scope.row)">删除</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
               </template>
             </el-table-column>
           </el-table>


            <div style="text-align: center;">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="task_list.current_page" :page-sizes="[10, 20, 30, 40]" :page-size="task_list.per_page"
                layout="total, sizes, prev, pager, next, jumper" :total="task_list.total">
              </el-pagination>
            </div>

          </div>
        </div>
      </div>

      <el-dialog :title="nav_status.train_change_dialog.title" :visible.sync="nav_status.train_change_dialog.status">
        <el-table stripe :data="nav_status.train_change_dialog.data" style="width: 100%">
          <el-table-column label="操作人" prop="companyee" width="" sortable>
          </el-table-column>
          <el-table-column label="操作详情" prop="content" width="" sortable>
          </el-table-column>
          <el-table-column label="时间" prop="c_time" width="" sortable>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="nav_status.train_change_dialog.status=false">关闭</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="nav_status.train_info_dialog.title" :visible.sync="nav_status.train_info_dialog.status">
        <div>
          培训主题：<span>{{nav_status.train_info_dialog.data.name}}</span>
        </div>
        <div>
          创建人：<span>{{nav_status.train_info_dialog.data.a_id}}</span>
        </div>
        <div>
          培训分类：<span>{{nav_status.train_info_dialog.data.t_id}}</span>
        </div>
        <div>
          培训级别：<span>
          <span v-if="nav_status.train_info_dialog.data.role_type=='0'">企业级</span>
          <span v-else-if="nav_status.train_info_dialog.data.role_type=='1'">部门级</span>
          <span v-else-if="nav_status.train_info_dialog.data.role_type=='2'">个人级</span></span>
        </div>
        <div>培训内容:
          <!-- <span v-if="nav_status.train_info_dialog.data.type=='0'">文档：
            <span v-for="(item,key) in nav_status.train_info_dialog.data.content.content" style="padding-right: 2rem;">{{item}}</span>
          </span>
          <span v-if="nav_status.train_info_dialog.data.type=='1'">公共视频：
            <span v-for="(item,key) in nav_status.train_info_dialog.data.content.content.public" style="padding-right: 2rem;">{{item}}</span>
            <br />
            内部视频：
            <span v-for="(item,key) in nav_status.train_info_dialog.data.content.content.local">{{item}}</span>
          </span> -->
          <el-row v-if="nav_status.train_info_dialog.data.type=='0'">
            <span>文档：{{file.length}}</span>
                <el-table
                :data="file"
                 border
                 height="250"
                style="width: 100%;margin-top: 1.25rem;">
                <el-table-column
                  label="序号"
                  align="center"
                  type="index"
                  :index="indexAdd"
                  width="50"/>
                 </el-table-column>
                <el-table-column
                  prop="name"
                  label="文件名称"
                 >
                </el-table-column>
                <el-table-column
                   prop="time"
                   width="150"
                   label="文件阅读时长(s)"
                  >
                </el-table-column>
              </el-table>
          </el-row>
          <el-row v-if="nav_status.train_info_dialog.data.type=='1'">
            <span>公共视频：{{yz_video.length}}</span>
            <span>内部视频：{{nb_video.length}}</span>
            <el-tabs type="border-card" style="margin-top: 1.25rem;"  >
              <el-tab-pane label="公共视频">
                <el-table
                :data="yz_video"
                border
                 height="250"
                style="width: 100%">
                <el-table-column
                  label="序号"
                  align="center"
                  type="index"
                  :index="indexAdd"
                  width="50"/>
                 </el-table-column>
                <el-table-column
                  prop="name"
                  label="视频名称"
                 >
                </el-table-column>

              </el-table>
              </el-tab-pane>
              <el-tab-pane label="内部视频">
                <el-table
                  :data="nb_video"
                  border
                   height="250"
                  style="width: 100%">
                  <el-table-column
                    label="序号"
                    align="center"
                    type="index"
                    :index="indexAdd"
                    width="50"/>
                   </el-table-column>
                  <el-table-column
                    prop="name"
                    label="视频名称">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </el-row>
          <br/>
           <span v-if="nav_status.train_info_dialog.data.content.subject.num!='0'">
             题库：{{nav_status.train_info_dialog.data.content.subject.subject}}<br />
             题数：{{nav_status.train_info_dialog.data.content.subject.num}}<br />
             时长：{{nav_status.train_info_dialog.data.content.subject.time}}<br />
             及格分：{{nav_status.train_info_dialog.data.content.subject.score}}<br />
             考核次数（含补考）：{{nav_status.train_info_dialog.data.content.subject.exam}}<br />
           </span>
        </div>
        <!-- <div>
          培训人员：
          <span v-for="(item,key) in nav_status.train_info_dialog.data.companyee" :key="key" style="padding-right: 2rem;">
            {{item.name}}
            （
              <span v-if="nav_status.train_info_dialog.data.content.subject.num!=0">
                <span v-if="item.status=='1'">
                  已完成
                  [
                   <span v-if="item.status_scord=='1'"  style="color: blue;cursor: pointer;" :title="'查看'+item.name+'的试卷'" @click="subject_list(nav_status.train_info_dialog.data,item)">通过</span>
                   <span v-else  style="color: red;cursor: pointer;" :title="'查看'+item.name+'的试卷'" @click="subject_list(nav_status.train_info_dialog.data,item)">未通过</span>
                  ]
                </span>
                <span v-else="item.status=='0'">未完成</span>
              </span>
              <span v-else>
                <span v-if="item.status=='1'">已完成</span>
                <span v-else="item.status=='0'">未完成</span>
              </span>
              [<span style="color: blue;cursor: pointer;" @click="train_companyee_remove(nav_status.train_info_dialog.data,key)">移除</span>]
            ）
          </span>
        </div> -->
        <el-row>
          培训人员任务状态:
          <span style="color: red;">未完成：{{num.incomplete_list.length}}</span>
          <span style="color: limegreen;">已完成：{{num.completed_list.length}}</span>
          <el-tabs type="border-card" style="margin-top: 1.25rem;">
            <el-tab-pane label="未完成">
              <el-table
              :data="num.incomplete_list"
              border
               height="250"
              style="width: 100%">
              <el-table-column
                label="序号"
                align="center"
                type="index"
                :index="indexAdd"
                width="50"/>
               </el-table-column>
              <el-table-column
                prop="name"
                label="姓名"
                width="150">
              </el-table-column>
              <el-table-column
                label="操作"
               >
                <template slot-scope="scope">
                  <el-button
                  @click="train_companyee_remove(nav_status.train_info_dialog.data,scope.row,num.incomplete_list,'incomplete_list')"
                  type="text" size="small">移除</el-button>
                </template>
              </el-table-column>
            </el-table>
            </el-tab-pane>
            <el-tab-pane label="已完成">
              <el-table
                :data="num.completed_list"
                border
                 height="250"
                style="width: 100%">
                <el-table-column
                  label="序号"
                  align="center"
                  type="index"
                  :index="indexAdd"
                  width="50"/>
                 </el-table-column>
                <el-table-column
                  prop="name"
                  label="姓名"
                  width="150">
                </el-table-column>
                <el-table-column
                  label="考核状态"
                  v-if="nav_status.train_info_dialog.data.content.subject.num!=0"
                 >
                  <template slot-scope="scope">
                    <span v-if="scope.row.status_scord=='0'" style="color: red;">
                      未通过
                    </span>
                    <span v-else>
                      通过
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                 >
                  <template slot-scope="scope">
                    <el-button
                    @click="train_companyee_remove(nav_status.train_info_dialog.data,scope.row,num.completed_list,'completed_list')"
                    type="text" size="small">移除</el-button>
                    <el-button
                     @click="subject_list(nav_status.train_info_dialog.data,scope.row)"
                     v-if="nav_status.train_info_dialog.data.content.subject.num!=0"
                     type="text" size="small">查看试卷</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        
        </el-row>
        <div>
          培训说明：<span>{{nav_status.train_info_dialog.data.info}}</span>
        </div>
        <div>
          培训周期：<span>{{nav_status.train_info_dialog.data.day}}天</span>
        </div>
        <div>
          创建时间：<span>{{nav_status.train_info_dialog.data.c_time}}</span>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="nav_status.train_info_dialog.status=false">关闭</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="nav_status.subject_list_dialog.title" :visible.sync="nav_status.subject_list_dialog.status">
        <el-table stripe :data="nav_status.subject_list_dialog.data" style="width: 100%">
          <el-table-column label="编号" prop="num" width="" sortable>
          </el-table-column>
          <el-table-column label="状态" prop="msg" width="" sortable>
          </el-table-column>
          <el-table-column label="考核时间" prop="time" width="" sortable>
          </el-table-column>
          <el-table-column width="" sortable>
            <template slot-scope="scope">
              <router-link tag="a" target="_blank" :to="'/task_subject?num='+scope.row.num">
                <el-button size="mini">查看</el-button>
              </router-link>
              <el-button size="mini" @click="subject_remove(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="nav_status.subject_list_dialog.status=false">关闭</el-button>
        </div>
      </el-dialog>

      <el-dialog title="发送状态" :visible.sync="jc_stare.dialog_show" >
       <p>总人员个人：{{jc_stare.show_list.companyee.length}} 失败个数：{{jc_stare.show_list.false_count}}</p>
         <div style="max-height: 500px;  overflow-x: auto;">
          <el-table
            ref="multipleTable"
            :data="jc_stare.show_list.companyee"
            tooltip-effect="dark"
            style="width: 100%; "
            @selection-change="handleSelectionChange"
            >
             <el-table-column
              type="selection"
              width="55"
              :selectable="selectable"
              >
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              >
            </el-table-column>
            <el-table-column label="状态">
            <template slot-scope="scope">
             <p v-if="scope.row.push" style="color: green;">成功</p>
             <p v-else style="color: red;">失败</p>
                  </template>
                </el-table-column>
          </el-table>
          </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="resend">重新发送</el-button>
          <el-button @click="jc_stare.dialog_show=false">关闭</el-button>
        </div>
      </el-dialog>

  </div>

</template>

<script>
  import load from '../../../../components/load.vue';

  export default {
    name: 'App',
    data() {
      return {
        nb_video:[],
        yz_video:[],
        file:[],
        num:{
          incomplete_num:'',
          completed_num:'',
          incomplete_list:[],
          completed_list:[],
        
        },
        edittask_name:{
          dialogVisible:false,
          input:'',
          item:{}
        },
        nav_status:{
          train_change_dialog:{
            title:'',
            status:false,
            data:[]
          },
          train_info_dialog:{
            title:'',
            status:false,
            data:{
              'content':{
                'content':{},
                'subject':{}
              },
            }
          },
          subject_list_dialog:{
            title:'',
            status:false,
            data:{},
          }
        },
        jc_stare:{//检测中的数据
          dialog_show:false,
          show_list:{
            companyee:[]
          },
          train:'',
          list:[],
          liad_show:false
        },
        task_list:{
          current_page: 1, // 当前页码
          total: 0, // 总条数
          per_page: 10,
        },
        search: '',
        liad_show:false
      }
    },
    components: {
      load:load
    },
    mounted() {
      this.get_list()
    },
    methods: {
      indexAdd(index) {
            return index + 1
          },
      changeEnddate(key,item){
        let _this=this
        _this.edittask_name.key=key
        _this.edittask_name.dialogVisible=true
        _this.edittask_name.input=item.name
      },
      edittask_ok(){
        let _this=this
        var data={
          'num':_this.task_list.list[_this.edittask_name.key].num,
          'name':_this.edittask_name.input
        }
        _this.axios.post('/v2/c_train/change_train_name',{data:data}).then(function(res) {
           if(res.status=='200'){
             if(res.data.code=='1'){
                _this.task_list.list[_this.edittask_name.key].name=data.name
                _this.edittask_name.dialogVisible=false
             }else{
               _this.$message.error(res.data.msg)
             }
           }else{
             _this.$message.error('服务器内部错误')
           }
         }).catch(function(error) {
           _this.$message.error('服务器内部错误')
         });
      },
      search_click(){
        this.get_list()
      },

      handleSelectionChange(val) {
       this.jc_stare.list= val
      },
      selectable(row){
       if(row.push){
         return false
       }else{
         return true
       }
      },

      resend(){
        let _this=this
        if(_this.jc_stare.list.length>0){
          _this.axios.post('/v2/c_train/train_push_companyee',{data:{'train':_this.jc_stare.train,'companyee':_this.jc_stare.list,'type':'online'}}).then(function(res) {
            if(res.status=='200'){
              if(res.data.code=='1'){
                 _this.push_status(_this.jc_stare.train)
              }else{
                _this.$message.error(res.data.msg)
              }
            }else{
              _this.$message.error('服务器内部错误')
            }
          }).catch(function(error) {
            _this.$message.error('服务器内部错误')
          });
        }else{
          _this.$message.error('请选择人员')
        }
      },

      push_status(train){
        let _this=this
        _this.liad_show=true
        _this.jc_stare.train=train
        _this.axios.post('/v2/c_train/train_push_status',{data:{'num':train,'type':'online'}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.jc_stare.show_list=res.data.data
              _this.jc_stare.dialog_show=true
               _this.liad_show=false
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      train_up(type,train){
        let _this=this
        if( type=='del'){
          _this.$confirm('确认删除么？').then(_ => {
           _this.axios.post('/v2/c_train/train_up',{data:{'type':type,'num':train.num,'train':'online'}}).then(function(res) {
             if(res.status=='200'){
               if(res.data.code=='1'){
                 _this.$message.success(res.data.msg)
                 _this.get_list()
               }else{
                 _this.$message.error(res.data.msg)
               }
             }else{
               _this.$message.error('服务器内部错误')
             }
           }).catch(function(error) {
             _this.$message.error('服务器内部错误')
           });
                   })
                   .catch(_ => {});
                   return

        }_this.liad_show=true
        _this.axios.post('/v2/c_train/train_up',{data:{'type':type,'num':train.num,'train':'online'}}).then(function(res) {
          _this.liad_show=false
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.get_list()
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      get_list(){
        let _this=this;
        _this.axios.get('/v2/c_train/get_list',{params:{'page':_this.task_list.current_page,'limit':_this.task_list.per_page,'type':'1','keyword':_this.search}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.task_list=res.data.data
              _this.task_list.per_page=parseInt(_this.task_list.per_page)
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      get_train_info(num){
        let _this=this
        _this.liad_show=true
        _this.axios.get('/v2/c_train/get_train_info',{params:{'num':num,'type':'online'}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.liad_show=false
              _this.nb_video=[]
              _this.yz_video=[]
              _this.file=[]
              _this.num.incomplete_num=0
              _this.num.completed_num=0
              _this.num.completed_list=[]
              _this.num.incomplete_list=[]
              
              _this.$set(_this.nav_status.train_info_dialog,'data',res.data.data)
              _this.nav_status.train_info_dialog.status=true
              
              for(let i=0;i<res.data.data.companyee.length;i++){
                if(res.data.data.companyee[i].status=='1'){
                  _this.num.completed_num++
                  _this.num.completed_list.push(res.data.data.companyee[i])
                }else{
                  _this.num.incomplete_num++
                  _this.num.incomplete_list.push(res.data.data.companyee[i])
              
                }
              }
              if(_this.nav_status.train_info_dialog.data.type=='0'){
                if(res.data.data.content.content[0]!=null){
                  for(let i=0;i<res.data.data.content.content.length;i++){
                    let data={
                      name:res.data.data.content.content[i].name,
                      time:res.data.data.content.content[i].time,
                      num:i
                    }
                    _this.file[i]=data
                  }
                }else{
                  _this.file=[]
                }
              }else{
                if(res.data.data.content.content.local[0]!=null){
                  for(let i=0;i<res.data.data.content.content.local.length;i++){
                    let data={
                      name:res.data.data.content.content.local[i],
                      num:i
                    }
                    _this.nb_video[i]=data
                  }
                }else{
                  _this.nb_video=[]
                }
                if(res.data.data.content.content.public[0]!=null){
                  for(let i=0;i<res.data.data.content.content.public.length;i++){
                    let data={
                      name:res.data.data.content.content.public[i],
                      num:i
                    }
                    _this.yz_video[i]=data
                  }
                }else{
                  _this.yz_video=[]
                }
              }

            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        })
      },

      train_change_watch(train){
        this.nav_status.train_change_dialog.title=train.name
        this.nav_status.train_change_dialog.data=train.change
        this.nav_status.train_change_dialog.status=true
      },

      train_info_watch(train){
        this.nav_status.train_info_dialog.title=train.name
        this.get_train_info(train.num)
      },

      // train_companyee_remove(train,companyee){
      //   let _this=this
      //   _this.axios.post('/v2/c_train/del_train_companee',{data:{'train':train.num,'companyee':_this.nav_status.train_info_dialog.data.companyee[companyee].num}}).then(function(res) {
      //     if(res.status=='200'){
      //       if(res.data.code=='1'){
      //         _this.$message.success(res.data.msg)
      //         _this.nav_status.train_info_dialog.data.companyee.splice(companyee, 1);
      //       }else{
      //         _this.$message.error(res.data.msg)
      //       }
      //     }else{
      //       _this.$message.error('服务器内部错误')
      //     }
      //   }).catch(function(error) {
      //     _this.$message.error('服务器内部错误')
      //   })
      // },
      train_companyee_remove(train,companyee,list,type){
        let _this=this
         _this.$confirm('确认将该员工移除吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  _this.train_del(train,companyee,list,type)
                }).catch(() => {
                  _this.$message({
                    type: 'info',
                    message: '已取消删除'
                  });
                });
      },
      train_del(train,companyee,list,type){
        let _this=this
        // _this.axios.post('/v2/c_train/del_train_companee',{data:{'train':train.num,'companyee':companyee.num}}).then(function(res) {
          _this.axios.post('/v2/c_train/del_train_companee',{data:{'train':train.num,'companyee':companyee.num}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              for(let i=0;i<list.length;i++){
                if(list[i].num==companyee.num){
                  if(type=='completed_list'){
                    _this.num.completed_list.splice(i, 1);
                  }else{
                    _this.num.incomplete_list.splice(i, 1);
                  }
                }
              }
              // _this.get_train_info(train.num)
              // _this.nav_status.train_info_dialog.data.companyee.splice(companyee, 1);
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            // _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          // _this.$message.error('服务器内部错误')
        })
      },

      subject_list(train,companyee){
        let _this=this
        _this.axios.get('/v2/c_train/get_train_companyee_exam',{params:{'train':train.num,'companyee':companyee.num}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.nav_status.subject_list_dialog.title=companyee.name+'['+train.name+']的考核试卷列表'
              _this.$set(_this.nav_status.subject_list_dialog,'data',res.data.data)
              _this.nav_status.subject_list_dialog.status=true
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        })
      },

      subject_remove(subject){
        let _this=this
        _this.axios.post('/v2/c_train/del_train_companyee_exam',{data:_this.nav_status.subject_list_dialog.data[subject].num}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.nav_status.subject_list_dialog.data.splice(subject, 1);
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        })
      },

      handleSizeChange(val) {
        this.task_list.current_page = 1;
        this.task_list.per_page = val;
        this.get_list();
      },
      handleCurrentChange(val) {
        let _this=this
        _this.task_list.current_page = val;
        _this.get_list();
      },
    }
  }
</script>

<style scoped>
  .alltext{
    margin: 20px;
    background-color: white;
    height: 100%;
    width: 95%;
    border:1px solid 	#9D9D9D;
  }
  .firstdiv{
    margin-top: 10px;

    width: 95%;
    height: 70px;
    display: flex;
    align-items: center;
    padding-left: 20px;
  }
  .content{
    width: 100%;
  }
  .content_right_first{
      margin: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .content_right{

      padding: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/view/company/train/Entry/Entry.vue